export interface WaveformBar {
  h: number;
  dim: boolean;
}

export interface WaveformPatternConfig {
  /** Total number of bars to render. */
  count: number;
  /** Repeating height sequence (px) — tiled across `count` bars via modulo. */
  heights: readonly number[];
  /** Fraction (0–1) of bars dimmed at each end of the row, e.g. 0.08 = 8%. */
  dimEdgeRatio: number;
}

/** Default pattern: dense 160-bar waveform with a 16-step height cycle, 8% dimmed at each edge. */
export const DEFAULT_WAVEFORM_PATTERN: WaveformPatternConfig = {
  count: 160,
  heights: [9, 16, 22, 14, 20, 7, 18, 11, 21, 13, 8, 19, 15, 5, 17, 10],
  dimEdgeRatio: 0.08,
};

/** Builds a bar list from a config: height cycles via modulo, edges dimmed per `dimEdgeRatio`. */
export const generateWaveformBars = (
  config: WaveformPatternConfig = DEFAULT_WAVEFORM_PATTERN
): ReadonlyArray<WaveformBar> => {
  const { count, heights, dimEdgeRatio } = config;
  const dimEdge = Math.round(count * dimEdgeRatio);

  return Array.from({ length: count }, (_, i) => ({
    h: heights[i % heights.length],
    dim: i < dimEdge || i >= count - dimEdge,
  }));
};
